jQuery(document).on(
  "click",
  "#shopify-product-reviews .spr-button",
  function () {
    setTimeout(function () {
      window.location.reload();
    }, 1500);
  }
);
function CurrentMenuslection() {
  const currentUrl = window.location.pathname;
  $(".menu-item>a").each(function () {
    if ($(this).attr("href") === currentUrl) {
      $(this).parent().addClass("current-menu-item");
    }
  });
  $(".submenu-item a").each(function () {
    if ($(this).attr("href") === currentUrl) {
      $(this).parents(".submenuchild").addClass("current-menu-item");
    }
  });
}
jQuery(document).ready(function () {
  jQuery('.faqsdatadetail').hide(500);
   setInterval(function(){
        console.log('chk availabel');
        $('.PRODUCT_ADD_CART').each(function(){
            //console.log($(this).attr('data-pid'));
        });
   },2000);




  CurrentMenuslection();
  //menuimagesupload();
  GetCartLoop();
  jQuery("body").addClass(
    window.location.pathname.replace(/[^a-zA-Z0-9 ]/g, "") + "_page Pagess"
  );
  ProductSinglePageGallery();
  Col = jQuery("body").find(".importantCollection ul li").length * 25;
  jQuery("body")
    .find(".importantCollection ul")
    .addClass("columns" + Col);

  jQuery(document).on("click", ".Searchbutton,.crossform", function () {
    jQuery(".SearchingForm").toggleClass("active");
    jQuery(".srachresultdata").removeClass("active");
    jQuery(".searchresultcntent").html("");
  });
  jQuery(".videoBannerSLider").slick({
    dots: true,
    infinite: true,
    speed: 1000,
    autoplaySpeed: 8000,
    autoplay: true,
  });
  $(".videoBannerSLider").on(
    "afterChange",
    function (event, slick, currentSlide) {
      if (currentSlide == 0) {
        $("video").trigger("play");
      } else {
        $("video").trigger("pause");
      }
    }
  );

jQuery(".HeaderSliderForHome").slick({
  dots: true,
  infinite: true,
  draggable: true,
  pauseOnFocus: true,
  pauseOnHover: true,
  autoplaySpeed: 8000,
  speed: 300,
  fade: true,
  cssEase: "linear",
  autoplay: true,
  arrows: true, // Desktop पर prev/next दिखेंगे
  responsive: [
    {
      breakpoint: 768, // 768px से नीचे
      settings: {
        arrows: true // सिर्फ arrows disable होंगे
      }
    }
  ]
});


  jQuery(".Recommended,.cartpage .CollectionProductList1").slick({
    infinite: true,
    autoplay: true,
    dots: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        // tablet
        breakpoint: 830,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true,
          cssEase: "linear",
          centerPadding: "20px",
          autoplaySpeed: 5000,
        },
      },
    ],
  });
  jQuery(".ImportantCollectionSlider").slick({
    infinite: true,
    autoplay: true,
    dots: false,
    speed: 5000,
    autoplaySpeed: 5000,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        // tablet
        breakpoint: 830,
        settings: {
          slidesToShow: 3,
          draggable:true,
          slidesToScroll: 3,          
          centerPadding: "10px",
          speed: 3000,
          autoplaySpeed: 4000,
        },
      },
    ],
  });
  jQuery(".CategoryBlock").slick({
    infinite: true,
    autoplay: true,
    dots: true,
    speed: 3000,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        // tablet
        breakpoint: 830,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true,
          cssEase: "linear",
          centerPadding: "20px",
          autoplaySpeed: 5000,
        },
      },
    ],
  });

  jQuery(".ProductsSliders").slick({
    infinite: true,
    autoplay: true,
    dots: true,
    speed: 3000,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        // tablet
        breakpoint: 830,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true,
          cssEase: "linear",
          centerPadding: "20px",
          autoplaySpeed: 5000,
        },
      },
    ],
  });
});
jQuery(document).on("mouseover", ".variations li", function () {
  path = jQuery(this).attr("data-img");
  jQuery(this)
    .parents(".CollectionProductListbox")
    .find(".ProductImagesSingles")
    .css("background", "url(" + path + ")");
});

jQuery(document).on("mouseout", ".CollectionProductListbox", function () {
  path = jQuery(this).find(".ProductImagesSingles").attr("data-img");
  jQuery(this)
    .find(".ProductImagesSingles")
    .css("background", "url(" + path + ")");
});

$(document).on("click", ".PRODUCT_ADD_CART", function () {
  PID = $(this).attr("data-pid");
  qun = parseInt($(this).data("qun"));
  ADDTOCART(PID, qun);
  $(this).append("<span></span>");
});

function ADDTOCART(PID, QUN = 1) {
  $("#myModal").modal("hide");
  if (isNaN(QUN)) {
    QUN = 1;
  }
  $(".modal-backdrop").addClass("in");
  $.ajax({
    method: "POST",
    url: "/cart/add",
    data: { id: PID, quantity: QUN },
  })
    .done(function (msg) {
      $.ajax({
        method: "GET",
        url: "/cart.json",
        data: { id: 0 },
      }).done(function (msg) {
        $(".PRODUCT_ADD_CART span").remove();
        console.log("Data Saved Cart Page", msg);
        $(".itemcount,.cartmenu a span").html(msg.item_count);
        $(".cartmenu a span").html(msg.item_count);
        $("#myModal").modal("show");
        $(".modaltotal").html('$'+msg.items_subtotal_price / 100);
        $(".modalftotal").html('$'+msg.total_price / 100);
        // alert(PID);
        for (i = 0; i < msg.items.length; i++) {
          if (msg.items[i].variant_id == PID) {
            $(".modal-body .cartproductsdetails .title").html(
              msg.items[i].product_title
            );
            console.log(msg.items[i]);
            $(".modal-body .cartproductsdetails .qun span").html(
              msg.items[i].quantity
            );
            $(".modal-body .cartproductsdetails .sku").html(
              "SKU#:" + msg.items[i].sku
            );
            let option = "";
            for (j = 0; j < msg.items[i].options_with_values.length; j++) {
              OP = msg.items[i].options_with_values[j];
              option +=
                "<div>" + OP.name + ": <span>" + OP.value + "</span></div>";
            }
            remove = "/cart/change?line=" + i + "&quantity=0";
            $(".modal-body .cartproductsdetails .variation").html(option);
            $(".modal-body .cartproductsdetails .removebtn a").attr(
              "href",
              remove
            );
            imgs = msg.items[i].image;
            $(".modal-body .cartproductsdetails .CARTIMG img").css(
              "background",
              "url(" + imgs + ")"
            );
          }
        }
      });
    })
    .fail(function (jqXHR, textStatus) {
      $(".PRODUCT_ADD_CART span").remove();
      Title = "Quantity Exceeds Available Stock";
      Msg =
        "The requested quantity exceeds the available stock for this product. Please adjust the quantity and try again.";
      Notify(Title, Msg, "red");
    })
    .always(function (jqXHR, textStatus) {
      //console.log("Ajax request was finished", jqXHR, textStatus);
    });
}

$(document).on("click", ".modal-header .close,.lbuttonsbox", function () {
  $("#myModal").modal("hide");
});
// Product Single Page SLider
function ProductSinglePageGallery() {
  $(".productthumnailGallery").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    infinite: false,
    draggable: true,
    fade: true,
    cssEase: "linear",
    asNavFor: ".productthumnail",
  });
  $(".productthumnail").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    asNavFor: ".productthumnailGallery",
    vertical: true,
    verticalSwiping: true,
    focusOnSelect: true,
    autoplay: false,
    draggable: true,
    infinite: true,
  });
  $(".Mproductthumnail").slick({
    slidesToShow: 3,
    infinite: true,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    asNavFor: ".productthumnailGallery",
    autoplaySpeed: 5000,
    focusOnSelect: true,
    draggable: true,
  });
}
jQuery(document).on("mouseover", ".submenuchild", function () {
  jQuery(".submenusData").removeClass("active");
  jQuery("body").removeClass("Removescroll");
  jQuery(this).find(".submenusData").addClass("active");
  jQuery("body").addClass("Removescroll");
});
//SubmenusBg 
jQuery(document).on("mouseout", ".SubmenusBg", function () {
  jQuery("body").removeClass("Removescroll");
});
jQuery(document).on("mouseover", ".submenuchild>a", function () {
  $("html, body").animate({ scrollTop: 0 }, "fast");
});

jQuery(document).on("click", ".closeicons img", function () {
  jQuery(".submenusData").removeClass("active");
  jQuery("body").removeClass("Removescroll");
});

jQuery(document).on("click", ".wishlist", function () {
  jQuery(this).toggleClass("active");
});

function GetCartLoop() {
  jQuery(".cartloop").each(function () {
    let vales = jQuery(this).find(".quantity input").val();
    jQuery(this).find(".quantity").find(".quantityStatus .qun").html(vales);
    Path = jQuery(this)
      .find(".updatelink")
      .attr("data-path")
      .replace("PP", vales);
    jQuery(this).find(".updatelink").attr("href", Path);
  });
}

jQuery(document).on("click", ".plus", function () {
  vals = parseInt($(this).parents(".quantity").find("input").val());
  $(this)
    .parents(".quantity")
    .find(".quantityStatus .qun")
    .html(vals + 1);
  $(this)
    .parents(".quantity")
    .find("input")
    .val(vals + 1);

  Path = jQuery(this)
    .parents(".cartloop")
    .find(".updatelink")
    .attr("data-path")
    .replace("PP", vals + 1);
  jQuery(this).parents(".cartloop").find(".updatelink").attr("href", Path);
});
jQuery(document).on("click", ".minus", function () {
  vals = parseInt($(this).parents(".quantity").find("input").val());
  NVal = vals - 1;
  if (NVal < 1) {
    NVal = 1;
  }
  $(this).parents(".quantity").find(".quantityStatus .qun").html(NVal);
  $(this).parents(".quantity").find("input").val(NVal);
  Path = jQuery(this)
    .parents(".cartloop")
    .find(".updatelink")
    .attr("data-path")
    .replace("PP", NVal);
  jQuery(this).parents(".cartloop").find(".updatelink").attr("href", Path);
});

function waitForElement(id, callback) {
  var poops = setInterval(function () {
    if (document.getElementById(id)) {
      clearInterval(poops);
      callback();
    }
    remove_blank_review();
  }, 100);
}

waitForElement("getRating", function () {
  $(".spr-summary-starrating").each(function () {
    THIIS = $(this).parents(".spr-summary");
    RAting = $(this).attr("aria-label").split("of")[0];
    REVIEW = THIIS.find("#getRating").html();
    NR = RAting + "(" + REVIEW + ")";
    THIIS.find("#getRating").html(NR);
    remove_blank_review();
  });
});

waitForElement("players", function () {
  $("#players").trigger("click");
});

function remove_blank_review() {
  if ($(".ProductDetailsPage").data("iscustomerlogin") == 0) {
    $(".spr-summary-actions").html("");
  }
  $(".noextradetailsinreview").each(function () {
    if ($(this).find(".spr-summary-caption").html() == "No reviews yet") {
      $(this).find(".spr-summary-caption").html("");
    }
  });
}

function Notify(title, msg, color = "blue") {
  $(".toast").toast("show");
  $(".toast .toast-header").attr("class", "toast-header");
  $(".toast .toast-header").addClass(color);
  $(".toast .toast-header strong").html(title);
  $(".toast .toast-body").html(msg);
}

$(document).on("keyup", ".SearchingBlock .inputboxes", function () {
  $(".srachresultdata").removeClass("active");
  if ($(this).val().length >= 3) {
    SearchResult($(this).val());
  } else {
    Notify(
      "Minimum Search Length",
      "Please enter at least 3 characters to initiate a search. Your input is currently below the required length. Thank you!"
    );
  }
});

function SearchResult(vals) {
  $(".toast").toast("hide");
  $.ajax({
    method: "GET",
    url: "/search/suggest.json",
    data: { type: "products", q: vals },
  })
    .done(function (msg) {
      $(".searchresultheading span").html(vals);
      console.log(msg.resources.results.products);
      html = "";
      if (msg.resources.results.products.length > 0) {
        for (i = 0; i < msg.resources.results.products.length; i++) {
          prod = msg.resources.results.products;
          title = prod[i].title;
          Img = prod[i].image;
          url = prod[i].url;
          Price = prod[i].price;

          html += '<div class="searchresultdata"><a href="' + url + '">';
          html +=
            '<div class="prodimg"><img style="background:url(' +
            Img +
            ')" src="https://ik.imagekit.io/hb9nqxxf2/Head/default_product.png?updatedAt=1686846980902"></div>';
          html += '<div class="prodtitle">' + title + "</div>";
          html += '<div class="prodprice">$' + Price + "</div>";
          html += "</a></div>";
        }
      } else {
        html +=
          '<div class="searchresultdata"><center>No Result Found</center></div>';
      }

      $(".searchresultcntent").html(html);
      $(".srachresultdata").addClass("active");
    })
    .fail(function (jqXHR, textStatus) {
      html = "";
      $(".srachresultdata").addClass("active");
      html +=
        '<div class="searchresultdata"><center>No Result Found</center></div>';
      $(".searchresultcntent").html(html);
    })
    .always(function (jqXHR, textStatus) {
      //console.log("Ajax request was finished", jqXHR, textStatus);
    });
}

function foractive(Class, Q = 5) {
  $("." + Class).on("afterChange", function (event, slick, currentSlide) {
    // Get the total number of dots (pagination items)
    var totalDots = slick.$dots.find("li").length;

    // Get the index of the active (current) dot
    var activeDotIndex = currentSlide;

    // Log the total number of dots and the index of the active dot to the console
    //console.log("Total Dots:", totalDots);
    //console.log("Active Dot Index:", activeDotIndex / Q + 1);
    $(this).find(".slikcounting").remove();
    $(this)
      .find(".slick-next")
      .after(
        '<span class="slikcounting">' +
          (activeDotIndex / Q + 1) +
          "/" +
          totalDots +
          "</span>"
      );
  });

  $("." + Class).on("init", function (event, slick, currentSlide) {
    // Get the total number of dots (pagination items)
    var totalDots = slick.$dots.find("li").length;

    // Get the index of the active (current) dot
    var activeDotIndex = currentSlide;

    // Log the total number of dots and the index of the active dot to the console
    console.log("Total Dots:", totalDots);
    console.log("Active Dot Index:", activeDotIndex / Q + 1);
    $(this).find(".slikcounting").remove();
    $(this)
      .find(".slick-next")
      .after('<span class="slikcounting">1/' + totalDots + "</span>");
  });
}

$(document).on("click", ".filtersforCollection .thirdlabel input", function () {
  if ($(this).is(":checked")) {
    window.location.href = $(this).parents("a.selectcollection").attr("href");
  }
});

$(document).on('change','select',function(){
  keyw=($(this).val()+'.');
  $('.productthumnail li').each(function(){
      text=($(this).find('img').attr('alt'));
      if(skeyword(text, keyw)){
        console.log(text,keyw);
          $(this).trigger('click');
      }
  });
})



function skeyword(txt, key) {
  var altText = txt;

  // Split the alt text based on a specific separator or keyword
  var keyword = key;
  var parts = altText.split(keyword);

  // Check if the keyword is found and retrieve the text after it
  if (parts.length > 1) {
    var textAfterKeyword = parts[1];
    return true;
  } else {
    return false;
  }
}
jQuery(document).on('click','.faqsdata .faqsdataheading',function(){
  jQuery('.faqsdatadetail').hide(100);  
  jQuery('.faqsdata').removeClass('active');
  jQuery(this).parents('.faqsdata').find('.faqsdatadetail').show(100); 
  jQuery(this).parents('.faqsdata').addClass('active');
});